export const FILTER_FORM_NAMES = {
  operator: 'operator',
  values: 'values',
} as const;
